import style from "./style.module.scss";
import SvgCheckboxOutlined from "components/svgs/checkbox-outlined";
import SvgFilledCheckBox from "components/svgs/filled/check-box";
import ValidationHelper from "@/utils/validation.util";

type CheckboxV3Type = {
  label?: string;
  name: string;
  checked?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  value?: string;
  customClass?: any;
  onChange: (e: any) => void;
  icon?: any;
};

const CheckboxV3 = ({
  label,
  name,
  checked = false,
  disabled = false,
  readonly = false,
  value,
  customClass,
  onChange,
  icon
}: CheckboxV3Type) => {
  const handleChange = (e: any) => {
    onChange(e);
  };
  return (
    <label
      htmlFor={name}
      className={`
        ${style.cItem} 
        ${readonly && style.cItem__readonly} 
        ${disabled && style.cItem__disabled}
        ${ValidationHelper.isPropertyNullOrEmpty(label) && style.cItem____noLabel}
        ${customClass}
      `}
    >
      <div className={style.cItem__fakeIconWrap}>
        {checked ? (
          !icon ? <SvgFilledCheckBox width="24px" /> : icon
        ) : (
          <SvgCheckboxOutlined width="24px" />
        )}
      </div>
      <input
        type="checkbox"
        name={name}
        id={name}
        checked={checked}
        disabled={disabled}
        readOnly={readonly}
        onChange={(e: any) => handleChange(e)}
        value={value ?? ""}
      />
      {label && <span>{label}</span>}
    </label>
  );
};

export default CheckboxV3;
